import React from 'react'
import cn from 'classnames'
import { Form, Select } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import Button from '../Button'

import PageHeader from '../PageHeader'
import { ROLE_OPTIONS, HEAR_ABOUT_US_OPTIONS } from '../../sharedForm/constants'

import sharedStyles from '../../sharedForm/styles.less'
import SaveIndicator from '../../sharedForm/SaveIndicator'

class OwnerPage extends React.PureComponent {
  state = {
    focusedField: null,
  }

  setHearAbout = value => {
    const { onChange, formFields } = this.props
    formFields.companyHearAboutUs = ''
    onChange('companyHearAboutUs', value, null, { validate: true })
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    if (name === 'companyHearAboutUsSelect') {
      if (value === 'Other') {
        this.setHearAbout('')
      } else {
        this.setHearAbout(value)
      }
    }
    if (name === 'companyHearAboutUsText') {
      this.setHearAbout(value)
    }
    onChange(name, value, null, { validate: true })
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    this.setState({ focusedField: null })
    onValidate(name, formFields[name])
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
    } = this.props
    const { focusedField } = this.state
    return (
      <React.Fragment>
        <PageHeader primary="Next, tell us about about yourself" />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV2)}
        >
          <Form.Field>
            <label htmlFor="name">Full name</label>
            <ValidatedField
              placeholder="What's your full name?"
              name="name"
              value={formFields.name}
              errorMessage={focusedField !== 'name' && formFieldsErrors.name}
              onChange={propFunc(this.handleChange, 'name')}
              onFocus={propFunc(this.handleFocus, 'name')}
              onBlur={propFunc(this.handleBlur, 'name')}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="companyRole">What is your role? (Optional)</label>
            <Select
              name="companyRole"
              className="large"
              options={ROLE_OPTIONS}
              value={formFields.companyRole}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'companyRole')}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="companyHearAboutUsSelect">
              How did you hear about us?
            </label>
            <Select
              name="companyHearAboutUsSelect"
              className="large"
              options={HEAR_ABOUT_US_OPTIONS}
              value={formFields.companyHearAboutUsSelect}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'companyHearAboutUsSelect')}
            />
          </Form.Field>
          <Form.Field>
            {formFields.companyHearAboutUsSelect === 'Other' && (
              <ValidatedField
                placeholder="How did you hear about us?"
                name="companyHearAboutUsText"
                value={formFields.companyHearAboutUsText}
                errorMessage={
                  focusedField !== 'companyHearAboutUsText' &&
                  formFieldsErrors.hearAboutUs
                }
                onChange={propFunc(this.handleChange, 'companyHearAboutUsText')}
                onFocus={propFunc(this.handleFocus, 'companyHearAboutUsText')}
                onBlur={propFunc(this.handleBlur, 'companyHearAboutUsText')}
                fieldRefCallback={disableLastPassInputRef}
                autoFocus
              />
            )}
          </Form.Field>
          <Button disabled={!canSave} onClick={submitForm}>
            {!saving ? (
              'Continue'
            ) : (
              <SaveIndicator animate>Saving</SaveIndicator>
            )}
          </Button>
        </Form>
      </React.Fragment>
    )
  }
}

export default OwnerPage
